import { z } from 'zod';

import type { UserCompanyNotificationDto } from '@/services/ws-comments/src/main/resources/rest-api';
import type { DateRangeType } from '@/js/libs/ui/src/V2';

import type { ColumnComponentPropsV2, ColumnV2 } from 'src/types.ts';

export type NotificationsFilterFields = {
  showRead: boolean;
  search: string;
  period: DateRangeType | null;
};

export const notificationsQueryParamsSchema = z.object({
  search: z.string().optional(),
});

export type NotificationsQueryParams = z.infer<typeof notificationsQueryParamsSchema>;

export type SystemNotificationColumnName = 'isRead' | 'title' | 'startDate';

export interface SystemNotificationColumnProps extends ColumnComponentPropsV2<SystemNotificationColumnName> {
  notification: UserCompanyNotificationDto;
  isMobile: boolean;
  ellipsizeLength: number;
}

export type SystemNotificationColumn = ColumnV2<SystemNotificationColumnName, SystemNotificationColumnProps>;
